module.exports = __webpack_public_path__ + "img/prohor_ai.cf5556a4.svg";